var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm._f("filtersTitle")(_vm.type),
            size: "80%",
            direction: "rtl",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.closeEdit,
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "150px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "归属公司：",
                    prop: "companyId",
                    rules: [
                      {
                        required: true,
                        message: "请选择归属公司",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("SelectCompay", {
                    attrs: { initCompanyId: _vm.detailInfo.companyId },
                    on: {
                      change: _vm.selectCompany,
                      selectCompany: _vm.selectCompany,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "归属客户：", prop: "customerId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择归属客户",
                      },
                      model: {
                        value: _vm.pram.customerId,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "customerId", $$v)
                        },
                        expression: "pram.customerId",
                      },
                    },
                    _vm._l(_vm.customerList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "小程序名称：",
                    prop: "appName",
                    rules: [
                      {
                        required: true,
                        message: "请填写小程序名称",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写小程序名称" },
                    model: {
                      value: _vm.pram.appName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "appName", $$v)
                      },
                      expression: "pram.appName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "小程序Logo：",
                    prop: "appLogo",
                    rules: [
                      {
                        required: true,
                        message: "请上传LOGO",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _vm.userType === 1
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("1", "appLogo")
                                },
                              },
                            },
                            [
                              _vm.pram.appLogo
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.pram.appLogo },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.appLogo
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "16px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("appLogo")
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                action: "",
                                "show-file-list": false,
                                "http-request": function (options) {
                                  return _vm.handleLocalUpload(
                                    options,
                                    "appLogo"
                                  )
                                },
                                "before-upload": _vm.beforeUpload,
                                accept: "image/*",
                              },
                            },
                            [
                              _vm.pram.appLogo
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.pram.appLogo },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.appLogo
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "20px",
                                  "margin-left": "10px",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("appLogo")
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "upload-tip",
                              staticStyle: { "margin-left": "10px" },
                            },
                            [_vm._v("支持jpg、png格式，不超过2MB")]
                          ),
                        ],
                        1
                      ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "小程序登录Logo：", prop: "appLoginLogo" } },
                [
                  _vm.userType === 1
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap(
                                    "小程序登录Logo",
                                    "appLoginLogo"
                                  )
                                },
                              },
                            },
                            [
                              _vm.pram.appLoginLogo
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.pram.appLoginLogo },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.appLoginLogo
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "16px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("appLoginLogo")
                                  },
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                action: "",
                                "show-file-list": false,
                                "http-request": function (options) {
                                  return _vm.handleLocalUpload(
                                    options,
                                    "appLoginLogo"
                                  )
                                },
                                "before-upload": _vm.beforeUpload,
                                accept: "image/*",
                              },
                            },
                            [
                              _vm.pram.appLoginLogo
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.pram.appLoginLogo },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.pram.appLoginLogo
                            ? _c("i", {
                                staticClass: "el-icon-delete",
                                staticStyle: {
                                  color: "red",
                                  "font-size": "20px",
                                  "margin-left": "10px",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeImg("appLoginLogo")
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "upload-tip",
                              staticStyle: { "margin-left": "10px" },
                            },
                            [
                              _vm._v(
                                "建议尺寸：180*180，支持jpg、png格式，不超过2MB"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "原始ID：",
                    prop: "originalId",
                    rules: [
                      {
                        required: true,
                        message: "请填写小程序原始ID",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写小程序原始ID" },
                    model: {
                      value: _vm.pram.originalId,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "originalId", $$v)
                      },
                      expression: "pram.originalId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "APPID：",
                    prop: "appId",
                    rules: [
                      {
                        required: true,
                        message: "请填写小程序APPID",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写小程序APPID" },
                    model: {
                      value: _vm.pram.appId,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "appId", $$v)
                      },
                      expression: "pram.appId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "uniAppId" } },
                [
                  _c(
                    "span",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _vm._v("\n          UniAppID：\n          "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "请勿随意改动，否则将无法上传",
                            placement: "top",
                          },
                        },
                        [_c("i", { staticClass: "el-icon-question" })]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "例如：__UNI__6610B0B",
                    },
                    model: {
                      value: _vm.pram.uniAppId,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.pram,
                          "uniAppId",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "pram.uniAppId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "AppSecret：",
                    prop: "appSecret",
                    rules: [
                      {
                        required: true,
                        message: "请填写小程序AppSecret",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写AppSecret" },
                    model: {
                      value: _vm.pram.appSecret,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "appSecret", $$v)
                      },
                      expression: "pram.appSecret",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "消息推送key：", prop: "messagePushKey" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写消息推送key" },
                    model: {
                      value: _vm.pram.messagePushKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "messagePushKey", $$v)
                      },
                      expression: "pram.messagePushKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "消息推送Token：", prop: "messagePushToken" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请填写消息推送Token",
                    },
                    model: {
                      value: _vm.pram.messagePushToken,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "messagePushToken", $$v)
                      },
                      expression: "pram.messagePushToken",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "消息推送加密密钥：",
                    prop: "messagePushEncodingAesKey",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请填写消息推送加密密钥",
                    },
                    model: {
                      value: _vm.pram.messagePushEncodingAesKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "messagePushEncodingAesKey", $$v)
                      },
                      expression: "pram.messagePushEncodingAesKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "工会福利金命名：", prop: "ljcName" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请填写工会福利金命名",
                    },
                    model: {
                      value: _vm.pram.ljcName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "ljcName", $$v)
                      },
                      expression: "pram.ljcName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "接口域名：", prop: "domain" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "接口域名" },
                    model: {
                      value: _vm.pram.domain,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "domain", $$v)
                      },
                      expression: "pram.domain",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "支付通道", prop: "payChannel" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择支付通道" },
                      model: {
                        value: _vm.pram.payChannel,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "payChannel", $$v)
                        },
                        expression: "pram.payChannel",
                      },
                    },
                    _vm._l(_vm.payChannelOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商户号：", prop: "merchantNo" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写商户号" },
                    model: {
                      value: _vm.pram.merchantNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "merchantNo", $$v)
                      },
                      expression: "pram.merchantNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商户key：", prop: "merchantKey" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写商户key" },
                    model: {
                      value: _vm.pram.merchantKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "merchantKey", $$v)
                      },
                      expression: "pram.merchantKey",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "证书序列号：", prop: "certSerialNo" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写证书序列号" },
                    model: {
                      value: _vm.pram.certSerialNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "certSerialNo", $$v)
                      },
                      expression: "pram.certSerialNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "证书路径：", prop: "certPath" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请填写证书文件绝对路径",
                    },
                    model: {
                      value: _vm.pram.certPath,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "certPath", $$v)
                      },
                      expression: "pram.certPath",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "主题色：" } },
                [
                  _c("el-color-picker", {
                    attrs: { "show-alpha": "" },
                    model: {
                      value: _vm.pram.appColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "appColor", $$v)
                      },
                      expression: "pram.appColor",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "小程序二维码地址：", prop: "appQrcodeUrl" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请填写小程序二维码地址",
                    },
                    model: {
                      value: _vm.pram.appQrcodeUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "appQrcodeUrl", $$v)
                      },
                      expression: "pram.appQrcodeUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分支名称：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请输入分支名称" },
                      model: {
                        value: _vm.pram.branchName,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "branchName", $$v)
                        },
                        expression: "pram.branchName",
                      },
                    },
                    _vm._l(_vm.branchNameList, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "购物指南链接：", prop: "shoppingGuideUrl" },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写购物指南链接" },
                    model: {
                      value: _vm.pram.shoppingGuideUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "shoppingGuideUrl", $$v)
                      },
                      expression: "pram.shoppingGuideUrl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "关联默认卡片id：", prop: "fudouCardId" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请填写关联默认卡片id",
                    },
                    model: {
                      value: _vm.pram.fudouCardId,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "fudouCardId", $$v)
                      },
                      expression: "pram.fudouCardId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "关联频道id：", prop: "channelId" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写关联频道id" },
                    model: {
                      value: _vm.pram.channelId,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "channelId", $$v)
                      },
                      expression: "pram.channelId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "搜索模块：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        clearable: "",
                        placeholder: "请选择搜索模块",
                      },
                      model: {
                        value: _vm.selectedSearchModules,
                        callback: function ($$v) {
                          _vm.selectedSearchModules = $$v
                        },
                        expression: "selectedSearchModules",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "外卖", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "团购", value: 2 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "酒店", value: 3 } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "search-modules-tip" }, [
                    _vm._v("商城为默认模块；不选择时不展示搜索模块切换栏"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "隐私政策：", prop: "privacyAgreement" } },
                [
                  _c("Tinymce", {
                    key: "privacy-" + _vm.editorKey,
                    staticClass: "editer",
                    model: {
                      value: _vm.pram.privacyAgreement,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "privacyAgreement", $$v)
                      },
                      expression: "pram.privacyAgreement",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "用户协议：", prop: "userAgreement" } },
                [
                  _c("Tinymce", {
                    key: "user-" + _vm.editorKey,
                    staticClass: "editer",
                    model: {
                      value: _vm.pram.userAgreement,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "userAgreement", $$v)
                      },
                      expression: "pram.userAgreement",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-btn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }